import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const AnalyticsListener: React.FC<{
  markPageLoaded: () => void;
  children: React.ReactNode;
}> = ({ markPageLoaded, children }) => {
  const location = useLocation();

  useEffect(() => {
    markPageLoaded();
  }, [location.pathname, markPageLoaded]);

  return <>{children}</>;
};
